import { useState } from "react"

export type UseLocalStorageReturn = [
    string,
    (newValue: string) => void
]

export const useLocalStorage = (initialValue: string, key: string): UseLocalStorageReturn => {
    const localeStorageSupported = typeof window !== "undefined" && typeof window.localStorage !== "undefined";

    const initialStateValue = window?.localStorage?.getItem(key) || initialValue;

    const [value, setStateValue] = useState<string>(initialStateValue);

    const setValue = (newValue: string) => {
        setStateValue(newValue);
        if (!localeStorageSupported) return;
        window.localStorage.setItem(key, newValue);
    }

    return [value, setValue];
}